export const extensionRoutes = [  {
    path: 'extensions/banner',
    loadChildren: () => import('./extensions/fe406f8a7d2a02b4ee5f557570919893f829838cf61d5bd542324bf715aaddf0/routes'),
  },
  {
    path: 'settings/shipping-methods',
    loadChildren: () => import('./extensions/shipping-method-detail/route'),
  },
  {
    path: 'extensions/sendcloud',
    loadChildren: () => import('./extensions/8ea6febec06a8832db453c565a29192184b927fc68e4134ae037ab755e11a226/routes'),
  },
  {
    path: 'extensions/product-reviews',
    loadChildren: () => import('./extensions/b2bb9a48868bc52eb47eb0151a84d2fd8e585f5da3b08af22cd6f6019d686168/routes'),
  },
  {
    path: 'extensions/invoice',
    loadChildren: () => import('./extensions/e52d94d9087795a184af3a94e69e34d91ed3c8b73b13a0eca48d7f25fb5560fa/routes'),
  },
  {
    path: 'extensions/seller-info',
    loadChildren: () => import('./extensions/seller-info/route'),
  },
  {
    path: 'extensions/chat',
    loadChildren: () => import('./extensions/chat-widget-vendure-plugin/routes'),
  }];
